import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import * as utility from "../statistics/services"
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { Helper } from "../core/util/helper";
import { SheetEventType } from "../../siteManagement/sheet";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";

export default class CRTemplate extends React.Component<CRTemplateProps, any> {
    common = new AppHelper();
    notificationHelper: NotificationHelper = new NotificationHelper();
    private _translations: {};
    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this._translations = this.props.metadata.additional.objects.filter(o => o.name == "translations")[0].data;
        this.initApp();
    }

    private initApp = () => {
        const sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (data) => {
            if (data.cmd == "addNewTags") {
                const tags: KeyValuePair<number, string>[] = Helper.getValueOrDefault(this.props.entity["ReportStructure"]["Tags"], []);
                data.tags.forEach((tag: string) => {
                    tags.push({ Key: tags.length, Value: tag });
                })
                const structure = this.props.entity["ReportStructure"];
                structure["Tags"] = tags;
                this.save(false);
            }
        })
    }

    save = (closeAfterSave) => {
        const reportStructure = this.props.entity["ReportStructure"];
        this.executeSave(reportStructure, reportStructure.Id, (result) => {
            if (result.Code == 0) {
                const entity = this.props.entity;
                entity.IsNew = false;
                Helper.updateEntity(this.props.entity, entity);
                NotificationHelper.showSuccessMessage("Saved successfully");
                if (!reportStructure.Id) {
                    this.props.changeRoute(result.Data);
                }
                this.common.handlePostSave(true, false);
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    copy = async () => {
        const reportStructure = this.props.entity["ReportStructure"];
        const result = await DialogHelper.prompt(this._translations["WebSMS.Report.Report.ReportForNewTemplate"], reportStructure.Title, 500);
        if (result) {
            reportStructure.Title = result;
            this.executeSave(reportStructure, null, (result) => {
                if (result.Code == 0) {
                    this.props.changeRoute(result.Data);
                    this.common.handlePostSave(true, false);
                }
                else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
        }
    }


    createNewVersion = () => {

        const reportStructure = this.props.entity["ReportStructure"];
        this.executeSave(reportStructure, reportStructure.Id, (result) => {
            if (result.Code == 0) {
                this.props.changeRoute(result.Data);
                this.common.handlePostSave(true, false);
            }
            else {

            }
        });
    }

    canCreateNewVersion = () => {
        if (this.props.entity["ReportStructure"]) {
            return this.props.entity["ReportStructure"].Released && !this.props.entity["ReportStructure"].Disabled;
        }
    }

    private executeSave(reportStructure: any, id: string, callBack: (result: any) => any) {
        if (!reportStructure || Helper.isNullOrEmpty(reportStructure.Title)) {
            NotificationHelper.showWarningMessage(Helper.getTranslation('WebSMS.Report.NoTitle'));
            return;
        }

        const getDescriptionUrl = "Reporting/SaveReportStructure";
        utility.httpService.postJson(Config.baseUrl + getDescriptionUrl, { reportStructure: JSON.stringify(reportStructure) }, callBack, null, { reportId: id }, true);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange({ model: "dummy" }, value, dataItem);
    }

    canRelease = () => {
        const canRelease = this.props.entity && this.props.entity["ReportStructure"] && !this.props.entity["ReportStructure"].Released && !this.props.entity["ReportStructure"].Disabled;
        return canRelease !== null ? canRelease : true;
    }

    release = async () => {
        const shouldRelease = await DialogHelper.confirm(this._translations["WebSMS.Reporting.ShouldRelase"], 500);
        if (shouldRelease) {
            const reportStructure = this.props.entity["ReportStructure"];
            this.executeSave(reportStructure, reportStructure.Id, (saveResult) => {
                const releaseUrl = "Reporting/ReleaseTemplate";
                if (saveResult.Code != 0) {
                    NotificationHelper.showErrorMessage(saveResult.Message);
                    return;
                }
                utility.httpService.postJson(Config.baseUrl + releaseUrl, null, (result) => {
                    if (result.Code == 0) {
                        NotificationHelper.showSuccessMessage("Saved successfully");
                        this.props.reloadTab();
                        this.common.handlePostSave(true, false);
                    }
                    else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }

                    if (!reportStructure.Id) {
                        this.props.changeRoute(saveResult.Data);
                    }
                }, null, { reportId: saveResult.Data }, true);
            });
        }
    }

    deleteTemplate = async () => {
        const shouldDelete = await DialogHelper.confirm(this._translations["WebSMS.Reporting.ShouldDelete"], 500);
        if (shouldDelete) {
            const reportStructure = this.props.entity["ReportStructure"];
            utility.httpService.postJson(Config.baseUrl + "Reporting/DeleteTemplate", null, (result) => {
                this.common.handlePostSave(true, false);
                General.Sheet.Manager.getTopMostSheet().hide();
            }, null, { reportId: reportStructure.Id }, true);
        }
    }

    exportTemplate = async () => {
        const reportStructure = this.props.entity["ReportStructure"];
        const url = Config.baseUrl + "CRTemplate/Exportreport?Ids=" + reportStructure.Id;
        this.openInNewBrowserTab(url);
    }

    public openInNewBrowserTab = (url: string) => {
        const dummyLink = $("<a>").text("click me!").attr({ href: url, target: "_blank" });
        $("body").append(dummyLink);
        dummyLink[0].click();
        dummyLink.remove();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        props.context.appHelper = this.common;
        return <CommonApp {...props} />;
    }
}

//CRReports
export interface CRTemplateProps extends AppBaseProps {
    entity: CRTEmplateEntity;
    reloadTab?: any;
    changeRoute?: any
}

interface CRTEmplateEntity extends Entity {
    ISGuid: string;
}